var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('OnRatiosEmploisSite',{attrs:{"agencyId":_vm.f_agency_id,"pointServicesId":_vm.f_point_services_id,"period":_vm.f_period}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }